"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __importDefault(require("lodash"));
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const Colors_1 = require("../../../../Colors");
const GlobalStateProvider_1 = require("../../../../GlobalStateProvider");
const common_1 = require("../../../../common");
const SurveyCheckBox_1 = require("./SurveyCheckBox");
const constant_1 = require("./constant");
const react_redux_1 = require("react-redux");
const account_1 = require("../../account");
// SurveyItem 컴포넌트
const SurveyItem = react_1.default.memo(({ index, item, isSubmit = false, isRegist, setChangeSurveyList, setChangeSurveyData }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const { isMobile, isDesktop } = (0, GlobalStateProvider_1.useGlobalState)();
    const [data, setData] = react_1.default.useState();
    const titleRef = react_1.default.useRef(null);
    const isTeacher = (0, react_redux_1.useSelector)((state) => (0, account_1.getIsTeacher)(state));
    // 드롭다운 값 상태
    const [dropValue, setDropValue] = react_1.default.useState(constant_1.DEFAULT_SURVEY_DROP);
    (0, react_1.useEffect)(() => {
        if (lodash_1.default.isEqual(item, data))
            return;
        const newDropValue = constant_1.SURVEY_DROP_LIST.find(drop => drop.id === item.type) || constant_1.DEFAULT_SURVEY_DROP;
        setDropValue(newDropValue);
        if (titleRef.current)
            titleRef.current.value = item.title || '';
        setData(item);
    }, [item]);
    (0, react_1.useEffect)(() => {
        if (!data)
            return;
        if (data?.title && titleRef.current)
            titleRef.current.value = data?.title;
    }, [data?.title]);
    // 드롭다운 변경 핸들러
    const handleDropChange = (dropItem) => {
        const isOptionType = (typeId) => typeId === constant_1.SURVEY_TYPE.CHECKBOX || typeId === constant_1.SURVEY_TYPE.OBJECTIVE;
        // 객관식↔체크형은 같은 선택지 배열 구조라 기존 선택지를 유지한다.
        // []로 리셋하면 화면(SurveyCheckBox 내부 state)에는 선택지가 남은 채 검증 데이터만 비어
        // 생성 시 '설문 항목을 추가해주세요'가 뜬다.
        const prevOptions = isOptionType(dropValue.id) && Array.isArray(data?.data) ? data?.data : [];
        const nextData = isOptionType(dropItem.id) ? prevOptions : '';
        setDropValue(dropItem);
        // @ts-ignore
        setData(prevData => ({
            ...prevData,
            type: dropItem.id,
            data: nextData,
        }));
        setChangeSurveyData({
            id: item.id,
            type: dropItem.id,
            data: nextData,
        });
    };
    const renderQuestion = (0, react_1.useMemo)(() => (react_1.default.createElement("div", { className: "survey-title" },
        react_1.default.createElement("p", null,
            " Q",
            index + 1,
            ". "),
        isRegist ? (react_1.default.createElement(common_1.InputElement, { ref: titleRef, className: `survey-input-title ${isMobile ? '' : 'body4 '}`, type: "text", placeholder: t('survey.inputQuestionPlaceholder'), onChange: value => {
                // @ts-ignore
                setData({ ...data, title: value });
                setChangeSurveyData({
                    // @ts-ignore
                    id: data.id,
                    title: value,
                });
            } })) : (react_1.default.createElement("p", null, data?.title)))), [isRegist, index, titleRef, data]);
    const renderType = (0, react_1.useMemo)(() => (
    /* 드롭다운 */
    react_1.default.createElement(common_1.DropDown, { className: "dropdown-mini", value: dropValue, list: constant_1.SURVEY_DROP_LIST, setDropValue: handleDropChange, option: {
            titleIcon: { show: false },
            itemIcon: { show: false },
        }, styles: {
            dropWrap: { width: isMobile ? '100%' : 95 },
            titleWrap: { backgroundColor: Colors_1.Colors.transparent, height: '100%' },
        }, isDisable: !isRegist })), 
    // data 누락 시 handleDropChange가 stale data(옛 선택지)를 캡처해 유형 전환 시 잘못 보존한다
    [dropValue, isRegist, data]);
    const render = (0, react_1.useMemo)(() => (
    /* 드롭다운 */
    react_1.default.createElement(common_1.DropDown, { className: "dropdown-mini", value: dropValue, list: constant_1.SURVEY_DROP_LIST, setDropValue: handleDropChange, option: {
            titleIcon: { show: false },
            itemIcon: { show: false },
        }, styles: {
            dropWrap: { width: isMobile ? '100%' : 95 },
            titleWrap: { backgroundColor: Colors_1.Colors.transparent, height: '100%' },
        }, isDisable: !isRegist })), [dropValue, isRegist]);
    const inputRef = react_1.default.useRef(null);
    react_1.default.useEffect(() => {
        if (!item)
            return;
        if (inputRef.current) {
            inputRef.current.value = item.data;
        }
    }, [item]);
    if (!data)
        return null;
    return (react_1.default.createElement("div", { className: "survey body4", key: index },
        react_1.default.createElement("div", { className: "survey-header" }, isMobile ? (react_1.default.createElement(react_1.default.Fragment, null,
            renderType,
            renderQuestion)) : (react_1.default.createElement(react_1.default.Fragment, null,
            renderQuestion,
            renderType))),
        react_1.default.createElement("div", { className: "survey-body" },
            react_1.default.createElement("div", { className: "survey-content" }, dropValue.id === constant_1.SURVEY_TYPE.CHECKBOX ||
                dropValue.id === constant_1.SURVEY_TYPE.OBJECTIVE ? (react_1.default.createElement(SurveyCheckBox_1.SurveyCheckBox
            // 유형 전환 시 리마운트해 내부 선택지 state를 상위 데이터(defaultList)로 재시드 — 화면·검증 데이터 불일치 방지
            , { 
                // 유형 전환 시 리마운트해 내부 선택지 state를 상위 데이터(defaultList)로 재시드 — 화면·검증 데이터 불일치 방지
                key: `${data.id}-${dropValue.id}`, id: data.id, isRadioButton: dropValue.id === 'choice', defaultList: data.data, isRegist: isRegist, isSubmit: isSubmit, isDisable: isTeacher, setChangeSurveyData: setChangeSurveyData })) : (react_1.default.createElement("div", { className: "textarea-item", style: { flex: 1 } }, (isTeacher && !isRegist) || isSubmit ? (react_1.default.createElement("div", { className: "input-answer", style: {
                    minWidth: dropValue.id === constant_1.SURVEY_TYPE.LONG_ANSWER
                        ? '100%'
                        : '150px',
                } }, item.data && item.data.length > 0 ? item.data : isSubmit ? '무응답' : '')) : (react_1.default.createElement(common_1.InputElement, { ref: inputRef, textRef: inputRef, className: "survey-input ", type: "text", style: dropValue.id === constant_1.SURVEY_TYPE.LONG_ANSWER
                    ? { height: 85, resize: 'none', overflow: 'hidden' }
                    : undefined, textarea: dropValue.id === constant_1.SURVEY_TYPE.LONG_ANSWER ? true : false, defaultValue: isRegist ? item.data : isSubmit ? item.data : '', onChange: value => {
                    const max = dropValue.id === constant_1.SURVEY_TYPE.LONG_ANSWER ? 300 : 100;
                    let limitedValue = value;
                    if (value.length >= max) {
                        if (!isDesktop) {
                            inputRef.current.blur();
                        }
                        setTimeout(() => {
                            window.alert(`최대 ${max}자까지 입력 가능합니다.`);
                        }, 100);
                        value = value.slice(0, max);
                    }
                    setData({ ...data, data: limitedValue });
                    setChangeSurveyData({
                        id: data.id,
                        data: limitedValue,
                    });
                }, isDisable: isTeacher || isSubmit, max: dropValue.id === constant_1.SURVEY_TYPE.LONG_ANSWER ? 300 : 100 }))))),
            isRegist && (react_1.default.createElement("div", { className: "survey-footer" },
                react_1.default.createElement(common_1.Button, { styles: {
                        buttonWrap: {
                            background: Colors_1.Colors.transparent,
                        },
                    }, onClick: () => setChangeSurveyList(item.id), option: {
                        buttonBeforeIcon: {
                            show: true,
                            name: 'del-survey',
                            size: isMobile ? 14 : 20,
                            color: Colors_1.Colors.black,
                        },
                    } }),
                react_1.default.createElement(common_1.Button, { styles: {
                        buttonWrap: {
                            background: Colors_1.Colors.transparent,
                        },
                    }, onClick: () => setChangeSurveyList(), option: {
                        buttonBeforeIcon: {
                            show: true,
                            name: 'add-survey',
                            size: isMobile ? 14 : 20,
                            color: Colors_1.Colors.black,
                        },
                    } }))))));
});
exports.default = SurveyItem;
